import FrontRoyalSpinner, { FRONT_ROYAL_SPINNER_ARIA_LABEL } from './FrontRoyalSpinner';

export default FrontRoyalSpinner;

export { FRONT_ROYAL_SPINNER_ARIA_LABEL };
